module.exports = __webpack_public_path__ + "img/img39.fe6b7b90.svg";